import React, { useState } from "react";
import "./LoginPage.scss";
import InputComponent from "./InputComponent";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authDataFun } from "../Toolkit/AuthSlice";
import { useNavigate } from "react-router-dom";
import ErrorData from "../Components/ErrorData";
import { notification } from "antd";

const LoginPage = () => {
  const [userLogin, setUserLogin] = useState({
    email: "",
    password: "",
  });
  const [loginError, setLoginError] = useState(false);

  const { currentUser, loading, error } = useSelector((prev) => prev?.auth);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const getUserdata = (e) => {
    setUserLogin((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const loginUser = () => {
    dispatch(authDataFun(userLogin))
      .then((resp) => {
        if (resp.meta.requestStatus === "fulfilled") {
          console.log("dchvbdjbdjdkj", resp);
          notification.success({ message: "User logged in successfully !." });
          navigate(`/${resp?.payload?.data?.id}/workplus/dashboard`);
        } else {
          setLoginError(true);
          notification.error({ message: "Something went wrong !." });
        }
      })
      .catch(() => {
        notification.error({ message: "Something went wrong !." });
        setLoginError(true);
      });
  };

  return (
    <div className="login-page">
      <div className="ractangle"></div>
      <div className="ractangle-two"></div>
      <div className="login-form">
        <h2 className="main-heading">Login</h2>
        <div className="py-4">
          <InputComponent
            icon={<i className="fa-regular side-icon fa-envelope"></i>}
            type="email"
            name="email"
            placeholder="Enter Your Email"
            onChange={getUserdata}
            // onChange={getUserdata()}
          />
          <InputComponent
            icon={<i className="fa-solid side-icon fa-lock"></i>}
            type="password"
            placeholder="Enter Your password"
            name="password"
            onChange={getUserdata}
          />
          {loginError ? (
            <ErrorData value={`Please Enter Right Username or Email`} />
          ) : (
            ""
          )}
        </div>
        <button onClick={() => loginUser()} className="login-btn">
          Login
        </button>
        <Link to={"/forgotPassword"} className="forget-pass">
          Forgot Password ?
        </Link>
        {/* <p className="account-not">
          Don't have an Account{" "}
          <Link className="going-link" to="/signup">
            Sign up
          </Link>
        </p> */}
      </div>
    </div>
  );
};

export default LoginPage;
